// ============================================================================
// SHOP Page
// Display all products from all collections
// ============================================================================

import React from 'react';
import ProductList from '../components/ProductList';
import './styles/Shop.css';

function Shop({ cartId, setCartId }) {
  // All products from all collections
  const coquetteProducts = [
    {
      id: 'coquette-1',
      name: 'Blush Ribbon Slip Dress',
      price: 799,
      currency: '₱',
      category: 'Coquette',
      description: 'Elegant blush-colored slip dress with delicate ribbon details',
      longDescription: 'Experience timeless elegance with our Blush Ribbon Slip Dress. Crafted from premium silk, this dress features delicate ribbon detailing that adds a romantic touch. Perfect for special occasions or elevating your everyday look. The soft blush tone complements any skin tone beautifully.',
      image: '/images/C1.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Blush', 'White', 'Rose'],
      rating: 5,
      reviews: 247,
    },
    {
      id: 'coquette-2',
      name: 'Pastel Cloud Cardigan',
      price: 649,
      currency: '₱',
      category: 'Coquette',
      description: 'Soft, cloud-like cardigan in pastel pink',
      longDescription: 'Wrap yourself in luxury with our Pastel Cloud Cardigan. Made from the softest materials, this cardigan feels like wearing a cloud. The pastel pink hue is both calming and sophisticated. Layer it over any outfit for instant elegance and warmth.',
      image: '/images/C2.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Pastel Pink', 'Lavender'],
      rating: 5,
      reviews: 98,
    },
    {
      id: 'coquette-3',
      name: 'Romantic Corset Blouse',
      price: 749,
      currency: '₱',
      category: 'Coquette',
      description: 'Victorian-inspired corset blouse with lace trim',
      longDescription: 'Make a statement with our Romantic Corset Blouse. Inspired by Victorian fashion, this blouse features intricate lace trim and a flattering corset structure. Perfect for creating an hourglass silhouette while maintaining comfort. Ideal for date nights or special events.',
      image: '/images/C3.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['White', 'Cream', 'Blush'],
      rating: 5,
      reviews: 311,
    },
    {
      id: 'coquette-4',
      name: 'Silk Charmeuse Slip',
      price: 599,
      currency: '₱',
      category: 'Coquette',
      description: 'Luxurious silk charmeuse slip with adjustable straps',
      longDescription: 'Indulge in luxury with our Silk Charmeuse Slip. Made from premium silk, this slip is buttery smooth against the skin. The adjustable straps ensure the perfect fit, while the elegant drape creates a sophisticated silhouette. Layer under any sheer top or wear alone.',
      image: '/images/C4.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Ivory', 'Champagne', 'Rose Gold'],
      rating: 5,
      reviews: 156,
    },
    {
      id: 'coquette-5',
      name: 'Lace Trim Camisole',
      price: 499,
      currency: '₱',
      category: 'Coquette',
      description: 'Delicate camisole with French lace trim',
      longDescription: 'Add a touch of elegance to your wardrobe with our Lace Trim Camisole. Featuring authentic French lace detailing, this camisole is both delicate and durable. Perfect as a standalone piece or layered under any outfit for an extra dash of romance.',
      image: '/images/C5.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['White', 'Black', 'Pink'],
      rating: 4,
      reviews: 203,
    },
    {
      id: 'coquette-6',
      name: 'Pearl Button Cardigan',
      price: 699,
      currency: '₱',
      category: 'Coquette',
      description: 'Creamy cardigan adorned with vintage pearl buttons',
      longDescription: 'Channel vintage charm with our Pearl Button Cardigan. Each button is a vintage pearl, adding timeless sophistication. The creamy color is versatile and pairs beautifully with any wardrobe. This cardigan is a staple piece for the coquette aesthetic.',
      image: '/images/C6.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Cream', 'Blush', 'Lavender'],
      rating: 5,
      reviews: 189,
    },
    {
      id: 'coquette-7',
      name: 'Velvet Babydoll Dress',
      price: 849,
      currency: '₱',
      category: 'Coquette',
      description: 'Soft velvet babydoll dress with bow details',
      longDescription: 'Feel absolutely adorable in our Velvet Babydoll Dress. Luxuriously soft velvet with playful bow details creates the perfect coquette look. The babydoll silhouette is flattering on all body types and the vibrant colors make this dress a showstopper.',
      image: '/images/C7.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Pink', 'Rose', 'Mauve'],
      rating: 5,
      reviews: 275,
    },
    {
      id: 'coquette-8',
      name: 'Sheer Overlay Top',
      price: 549,
      currency: '₱',
      category: 'Coquette',
      description: 'Ethereal sheer overlay with embroidered details',
      longDescription: 'Layer like a pro with our Sheer Overlay Top. The ethereal sheer fabric features delicate embroidered details that add visual interest. Perfect for creating sophisticated, multi-layered looks. Mix and match with any top for endless styling possibilities.',
      image: '/images/C8.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['White', 'Blush', 'Peach'],
      rating: 4,
      reviews: 142,
    },
    {
      id: 'coquette-9',
      name: 'Satin Bow Headpiece',
      price: 399,
      currency: '₱',
      category: 'Coquette',
      description: 'Luxurious satin bow for hair styling',
      longDescription: 'Complete your coquette look with our Satin Bow Headpiece. Made from luxurious satin, this bow is both elegant and comfortable. The perfect accessory for formal events or adding a touch of femininity to everyday outfits. Available in multiple colors to match any ensemble.',
      image: '/images/C9.jpg',
      sizes: ['One Size'],
      colors: ['Pink', 'White', 'Black'],
      rating: 5,
      reviews: 421,
    },
    {
      id: 'coquette-10',
      name: 'Lace Thigh Highs',
      price: 299,
      currency: '₱',
      category: 'Coquette',
      description: 'Delicate lace thigh-high socks with bow trim',
      longDescription: 'Elevate your look with our Lace Thigh Highs. Delicate lace with cute bow trim at the top creates an irresistibly charming silhouette. Perfect with skirts or as a standalone statement piece. Comfortable elastic ensures they stay in place all day.',
      image: '/images/C10.jpg',
      sizes: ['One Size'],
      colors: ['White', 'Black', 'Pink'],
      rating: 5,
      reviews: 356,
    },
  ];

  const y2kProducts = [
    {
      id: 'y2k-1',
      name: 'Y2K Butterfly Mini Skirt',
      price: 549,
      currency: '₱',
      category: 'Y2K',
      description: 'Low-rise mini skirt with butterfly print',
      image: '/images/Y1.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Black', 'Pink', 'Purple'],
      rating: 5,
      reviews: 132,
    },
    {
      id: 'y2k-2',
      name: 'Cargo Pants with Straps',
      price: 699,
      currency: '₱',
      category: 'Y2K',
      description: 'Classic cargo pants with multiple pockets and straps',
      image: '/images/Y2.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Khaki', 'Black', 'Hot Pink'],
      rating: 5,
      reviews: 267,
    },
    {
      id: 'y2k-3',
      name: 'Metallic Crop Top',
      price: 449,
      currency: '₱',
      category: 'Y2K',
      description: 'Shiny metallic crop top perfect for the club',
      image: '/images/Y3.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Silver', 'Gold', 'Purple'],
      rating: 4,
      reviews: 198,
    },
    {
      id: 'y2k-4',
      name: 'Baby Tee Graphic Print',
      price: 399,
      currency: '₱',
      category: 'Y2K',
      description: 'Vintage-style baby tee with trendy graphic',
      image: '/images/Y4.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['White', 'Black', 'Pink'],
      rating: 5,
      reviews: 445,
    },
    {
      id: 'y2k-5',
      name: 'Butterfly Hair Clips',
      price: 299,
      currency: '₱',
      category: 'Y2K',
      description: 'Colorful butterfly hair clips set',
      image: '/images/Y5.jpg',
      sizes: ['One Size'],
      colors: ['Rainbow', 'Pink', 'Purple'],
      rating: 5,
      reviews: 512,
    },
    {
      id: 'y2k-6',
      name: 'Choker Necklace Set',
      price: 349,
      currency: '₱',
      category: 'Y2K',
      description: 'Multi-piece choker set with various styles',
      image: '/images/Y6.jpg',
      sizes: ['One Size'],
      colors: ['Black', 'Silver', 'Rainbow'],
      rating: 5,
      reviews: 389,
    },
    {
      id: 'y2k-7',
      name: 'Holographic Windbreaker',
      price: 799,
      currency: '₱',
      category: 'Y2K',
      description: 'Futuristic holographic windbreaker jacket',
      image: '/images/Y7.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Silver', 'Iridescent'],
      rating: 5,
      reviews: 234,
    },
    {
      id: 'y2k-8',
      name: 'Rhinestone Tank Top',
      price: 499,
      currency: '₱',
      category: 'Y2K',
      description: 'Sparkly tank top covered in rhinestones',
      image: '/images/Y8.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Black', 'White', 'Pink'],
      rating: 5,
      reviews: 267,
    },
    {
      id: 'y2k-9',
      name: 'Platform Chunky Sneakers',
      price: 899,
      currency: '₱',
      category: 'Y2K',
      description: 'Iconic platform chunky sneakers with colorful details',
      image: '/images/Y9.jpg',
      sizes: ['5', '6', '7', '8', '9', '10'],
      colors: ['White/Pink', 'White/Purple', 'Black/Silver'],
      rating: 5,
      reviews: 198,
    },
    {
      id: 'y2k-10',
      name: 'Butterfly Chain Wallet',
      price: 449,
      currency: '₱',
      category: 'Y2K',
      description: 'Cute butterfly-shaped wallet with chain strap',
      image: '/images/Y10.jpg',
      sizes: ['One Size'],
      colors: ['Pink', 'Purple', 'Blue'],
      rating: 5,
      reviews: 356,
    },
  ];

  const fairycoreProducts = [
    {
      id: 'fairycore-1',
      name: 'Tulle Ballerina Skirt',
      price: 749,
      currency: '₱',
      category: 'Fairycore',
      description: 'Ethereal tulle skirt with multiple layers',
      image: '/images/f1.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Mint Green', 'Lavender', 'Blush'],
      rating: 5,
      reviews: 274,
    },
    {
      id: 'fairycore-2',
      name: 'Floral Fairy Maxi Dress',
      price: 999,
      currency: '₱',
      category: 'Fairycore',
      description: 'Long flowing dress with enchanted floral print',
      image: '/images/f2.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Sage Green', 'Ivory', 'Dusty Rose'],
      rating: 5,
      reviews: 189,
    },
    {
      id: 'fairycore-3',
      name: 'Woodland Fairy Wings',
      price: 599,
      currency: '₱',
      category: 'Fairycore',
      description: 'Delicate iridescent fairy wings accessory',
      image: '/images/f3.jpg',
      sizes: ['One Size'],
      colors: ['Iridescent', 'Rainbow', 'Mint'],
      rating: 5,
      reviews: 421,
    },
    {
      id: 'fairycore-4',
      name: 'Moss Green Corset Top',
      price: 649,
      currency: '₱',
      category: 'Fairycore',
      description: 'Enchanted corset top in moss green with nature details',
      image: '/images/f4.jpg',
      sizes: ['XS', 'S', 'M'],
      colors: ['Moss Green', 'Forest Green', 'Sage'],
      rating: 5,
      reviews: 156,
    },
    {
      id: 'fairycore-5',
      name: 'Forest Spirit Crown',
      price: 699,
      currency: '₱',
      category: 'Fairycore',
      description: 'Magical crown with woodland elements and gemstones',
      image: '/images/f5.jpg',
      sizes: ['One Size'],
      colors: ['Gold/Green', 'Silver/Mint', 'Bronze/Sage'],
      rating: 5,
      reviews: 312,
    },
  ];

  const allProducts = [...coquetteProducts, ...y2kProducts, ...fairycoreProducts];

  return (
    <div className="shop-page">
      <div className="shop-header">
        <h1>Shop All Products</h1>
        <p>Discover our complete collection of coquette, Y2K, and fairycore pieces</p>
      </div>
      <ProductList products={allProducts} loading={false} showFilters={true} />
    </div>
  );
}

export default Shop;
